import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { config } from 'process';
import { ConfirmDialogModel } from '../components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { OkDialogModel } from '../components/ok-dialog/ok-dialog-model';
import { OkDialogComponent } from '../components/ok-dialog/ok-dialog.component';
import { PromptDialogComponent } from '../components/prompt-dialog/prompt-dialog.component';
import { OnSaveClickEvent, PromptDialogModel } from '../entities/prompt.dialog.model';

@Injectable({
    providedIn: 'root'
})
export class CommonDialogService {

    constructor(
        private dialog: MatDialog,
    ) { }


    /**
     * Open prompt dialog and returns its reference
     * @param onSaveClick Save click event. If this function returns true, dialog will be closed. Loading
     * icon will be diaplayed while this function is being executed
     * @param isInputRequired If true, an input is required
     * @param initialText Initial text to display
     */
    public openPromptDialog(
        title: string, onSaveClick: OnSaveClickEvent, isInputRequired = true, initialText = "",
    ) {
        return this.dialog.open<PromptDialogComponent, PromptDialogModel, any>(
            PromptDialogComponent,
            {
                data: {
                    initialText,
                    isInputRequired,
                    onSaveClick,
                    title,
                }
            }
        );
    }


    /**
     * Open a confirmation dialog
     */
    public openConfirmationDialog(
        title: string,
        message: string = "",
    ) {
        const dialogData = new ConfirmDialogModel(title, message);

        return this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });
    }


    /**
     * Open a OK dialog
     */
    public openOkDialog(
        title: string,
        message: string = "",
    ) {
        const dialogData = new OkDialogModel(title, message);

        return this.dialog.open(OkDialogComponent, {
            data: dialogData
        });
    }

}
